import { defineComponent as _defineComponent } from 'vue'
import { FormItem } from '@/interfaces/lib/model';
import {
  SdsProduct,
  SdsSection3ImpurityMaterial,
  SdsSection3Material,
  SdsSection8ExposureControlMaterial,
} from '@/interfaces/model/general/sds';
import { getMaterialNameList } from '@/lib/formItem';
import sharedMessages from '@/lib/shared-messages';
import { now } from '@/utils/datetime';
import { computed, onMounted, ref } from 'vue';
import { VForm } from 'vuetify/lib/components';


export default /*#__PURE__*/_defineComponent({
  __name: 'MaterialNameAndCasForm',
  props: {
    isEditing: { type: Boolean },
    isValid: { type: Boolean },
    sdsId: null,
    sdsSection8ExposureControlId: null,
    materialList: null,
    products: null
  },
  emits: ["update:isValid", "update:materialList"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'update:isValid', data: boolean): void;
  (e: 'update:materialList', data: SdsSection8ExposureControlMaterial[]): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  isEditing: boolean;
  isValid: boolean;
  sdsId: string;
  sdsSection8ExposureControlId: number;
  materialList: SdsSection8ExposureControlMaterial[];
  products: SdsProduct[];
};




const form = ref<InstanceType<typeof VForm> | null>(null);

const validMaterialList = computed<SdsSection8ExposureControlMaterial[]>(() => {
  return props.materialList.filter((m) => !m.deleted_at);
});

const materialFormItems = computed((): Array<FormItem> => {
  const material_names: Array<FormItem> = [...getMaterialNameList()];
  const nameSet = new Set(material_names.map((item) => item.value));

  for (const product of props.products) {
    for (const material of product.sds_section3.material_list) {
      if (!nameSet.has(material.material_name)) {
        material_names.push({
          text: material.material_name,
          value: material.material_name,
        });
        nameSet.add(material.material_name);
      }
    }
    for (const material of product.sds_section3.impurity_list) {
      if (!nameSet.has(material.material_name)) {
        material_names.push({
          text: material.material_name,
          value: material.material_name,
        });
        nameSet.add(material.material_name);
      }
    }
  }

  return material_names;
});

const casFormItems = (
  mat: SdsSection8ExposureControlMaterial
): Array<FormItem> => {
  const materialList: Array<SdsSection3Material | SdsSection3ImpurityMaterial> =
    [];
  for (const product of props.products) {
    for (const material of product.sds_section3.material_list) {
      if (material.material_name === mat.material_name) {
        materialList.push(material);
      }
    }
    for (const material of product.sds_section3.impurity_list) {
      if (material.material_name === mat.material_name) {
        materialList.push(material);
      }
    }
  }

  const casList: Array<FormItem> = [];
  for (const material of materialList) {
    for (const cas of material.cas_list) {
      casList.push({
        text: cas.cas_number,
        value: cas.cas_number,
      });
    }
  }
  // Remove duplicates by CAS number that can happen because of materials and impurities
  // Both having the same CAS number
  const seen = new Set<string>();
  const uniqueCasList = casList.filter((item) => {
    if (seen.has(item.value)) return false;
    seen.add(item.value);
    return true;
  });
  return uniqueCasList;
};

const updateMaterialName = (e: string | FormItem, index: number) => {
  const materialList = structuredClone(props.materialList);
  materialList[index].material_name = e?.value ?? e;

  emits('update:materialList', materialList);
};

const updateCas = (e: Array<string | FormItem>, index: number): void => {
  const cas = e.map((x) => x.value ?? x);
  const materialList = structuredClone(props.materialList);
  materialList[index].cas_list = cas;

  emits('update:materialList', materialList);
};

const deleteMaterial = (index: number): void => {
  const materialList = structuredClone(props.materialList);
  materialList[index].deleted_at = now().toISO();

  emits('update:materialList', materialList);
};

const addMaterial = (): void => {
  const materialList = structuredClone(props.materialList);
  materialList.push({
    id: 0,
    sds_id: props.sdsId,
    sds_section8_exposure_control_id: props.sdsSection8ExposureControlId,
    material_name: '',
    cas_list: [],
    created_at: now().toISO(),
    updated_at: now().toISO(),
    deleted_at: null,
  });

  emits('update:materialList', materialList);
};

const updateIsValid = (e: boolean): void => {
  emits('update:isValid', e);
};

onMounted((): void => {
  if (form.value) {
    form.value.validate();
  }
});

return { __sfc: true,props, emits, form, validMaterialList, materialFormItems, casFormItems, updateMaterialName, updateCas, deleteMaterial, addMaterial, updateIsValid, sharedMessages, VForm }
}

})